import React from "react"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import ItemSku from "shared/hubrise/items/ItemSku"
import { IProduct } from "shared/hubrise/models"

const useItemSku = (product: IProduct) => {
  const { catalog } = useEditor()
  const { variantRef } = useCatalogNavigation()

  const itemSku = React.useRef<ItemSku>(new ItemSku(catalog, product)).current
  const [, rerender] = React.useReducer((x: number) => x + 1, 0)

  return {
    sku: itemSku.sku,
    optionLists: itemSku.optionLists,
    optionNames: (optionListName: string) => itemSku.optionNames(optionListName),
    price: itemSku.price(variantRef),
    setSkuName: (skuName: string): void => {
      itemSku.setSkuName(skuName)
      rerender()
    },
    setOptionNames: (optionListName: string, optionNames: Array<string>): void => {
      itemSku.setOptionNames(optionListName, optionNames)
      rerender()
    },
  }
}

export default useItemSku
